import classnames from 'classnames';
import React, { FC, Suspense } from 'react';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { useViewType, ViewType } from '@eika/hooks';

import ANALYTICS_CATEGORIES from '../../analytics/categories';
import { AccountActions } from '../../components/AccountActions';
import { FavoriteAccountSkeleton } from '../../components/FavoriteAccount';
import { FocusContext } from '../../components/NettbankCreateTransactions/hooks/useFocusContext';
import FocusMulitformModalSkeleton from '../../components/transaction/MultiformWrapper/FocusMulitformModalSkeleton';
import FocusMultiformModal from '../../components/transaction/MultiformWrapper/FocusMultiformModal';
import { SigningContextProvider } from '../../signingContext/signingContext';
import FavoriteAccountErrorCatcher from './FavoriteAccountErrorCatcher';
import MobileAccountContent from './MobileAccountContent';

import './FavoriteAccount.scss';

const FavoriteAccountWidget: FC = () => {
    const viewType = useViewType();

    if (viewType !== ViewType.desktop) {
        return (
            <div className={classnames('favorite-account-widget', { native: runningInRNWebView })}>
                <FavoriteAccountErrorCatcher>
                    <Suspense fallback={<FavoriteAccountSkeleton />}>
                        <MobileAccountContent />
                        <AccountActions />
                    </Suspense>
                </FavoriteAccountErrorCatcher>
            </div>
        );
    }

    return (
        <div className="favorite-account-widget">
            <SigningContextProvider analyticsCategory={ANALYTICS_CATEGORIES.PAYMENT}>
                <FocusContext>
                    <FavoriteAccountErrorCatcher>
                        <Suspense fallback={<FocusMulitformModalSkeleton />}>
                            <FocusMultiformModal />
                        </Suspense>
                    </FavoriteAccountErrorCatcher>
                </FocusContext>
            </SigningContextProvider>
        </div>
    );
};

export default FavoriteAccountWidget;
